import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Panel } from '@app/components';
import { TimesheetForm } from './TimesheetForm';
import { useToast, useTriptych } from '@app/hooks';
import { fromTimesheetForm, toTimesheetForm } from './timesheet-form.helpers';
import { timesheetApi } from '@app/store';

export const TimesheetCreate = memo(() => {
  const toast = useToast();
  const triptych = useTriptych();

  const [create, { isLoading, error: apiErrors }] = timesheetApi.useCreateOneTimesheetsMutation();

  const formMethods = useForm({
    defaultValues: toTimesheetForm(),
  });

  const onCreate = async (data: ReturnType<typeof toTimesheetForm>) => {
    try {
      const timesheet = await create(fromTimesheetForm(data)).unwrap();
      triptych.close({ mode: 'UPDATE', data: timesheet });
      toast.success('Le pointage a bien été ajouté.');
    } catch {
      toast.error('Une erreur est survenue lors de la création du pointage.');
    }
  };

  return (
    <Fragment>
      <Form formMethods={formMethods} apiErrors={apiErrors}>
        <Panel.Content>
          <Panel.FormContainer>
            <TimesheetForm />
          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>
        </Panel.Content>
      </Form>
    </Fragment>
  );
});

